import debounce from "debounce";
import Flickity from "flickity";

require("flickity/dist/flickity.css");

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
}

export default {
    init() {},
    finalize() {

        if (document.querySelector('.results-testimonials-carousel') !== null) {

            new Flickity(".results-testimonials-carousel", {
                cellAlign: "left",
                wrapAround: true,
                autoPlay: 3000,
                selectedAttraction: 0.1,
                friction: 1,
                prevNextButtons: true,
                pageDots: false
            });

        }

        const sticky_sidebar_el = jQuery('.results-pack-card');
        if ( sticky_sidebar_el.length ) {
            const sticky_sidebar = new Sticksy('.results-pack-card');
            if ( jQuery(window).width() >= 1024 ) {
                sticky_sidebar.enable();
            } else {
                sticky_sidebar.disable();
            }

            jQuery(window).on('resize', function(){
                if ( jQuery(window).width() >= 1024 ) {
                    sticky_sidebar.enable();
                } else {
                    sticky_sidebar.disable();
                }
            });
        }

        jQuery('.results-faq-item-question').click( function() {
            jQuery(this).siblings('.results-faq-item-answer').stop().slideToggle();
            jQuery(this).parent('.results-faq-item').toggleClass('open');
        })

        jQuery('.results__learn-more').click(function() {
            jQuery(this).siblings('.results__read-more').slideDown();
            jQuery(this).remove();
        });

        jQuery('.ingredients-link a').click(function(e) {
            e.preventDefault();

            const href = jQuery(this).attr('href');
            jQuery('html, body').animate({
                scrollTop: jQuery(href).offset().top - 80
            }, 300);
        });

        jQuery(document).on("click", ".cart__choice", function (event) {
            if (!jQuery(this).hasClass("cart__choice--selected")) {
                var choice = jQuery(this).attr("data-value");

                jQuery(this).addClass("clicked");

                jQuery("[name='cart_type']").val(choice);
                update_cart();
            }
        });

        jQuery(document).on("change", "input.qty", debounce(update_cart, 300));

        function update_cart() {
            jQuery("[name='update_cart']").removeAttr("disabled");
            jQuery("[name='update_cart']").trigger("click");
        }

        jQuery(document).on("click", "results__learn-more", function (event) {
            console.log("results click");
            console.log(jQuery(this));
            jQuery(this).siblings(".results__read-more").slideDown();
            jQuery(this).remove();
        });

        document.addEventListener("click", function (event) {
            const el = event.target;
            if (el.classList.contains("results__learn-more")) {
                jQuery(event.target)
                    .siblings(".results__read-more")
                    .slideDown();
                jQuery(event.target).remove();
            }
            if (
                el.classList.contains("subscribe-3-tooltip-inner") ||
                el.classList.contains("subscribe-3-tooltip-icon")
            ) {
                jQuery(".subscribe-3-tooltip").toggleClass("show-tooltip");
            }
        });
        // remove coupon cookie if Remove clicked on coupon
        document.addEventListener("click", function (event) {
            const el = event.target;
            if (el.classList.contains("woocommerce-remove-coupon")) {
                console.log("click remove coupon");
                event.preventDefault();
                const coupon = el.dataset.coupon;
                console.log("coupon", coupon);
                let cookie = getCookie("gp_coupon_from_url");
                cookie = decodeURIComponent(cookie);
                cookie = cookie.split("+").join(" ");
                console.log("cookie", cookie);
                if (cookie.toUpperCase() == coupon.toUpperCase()) {
                    console.log("remove coupon!");
                    document.cookie =
                        "gp_coupon_from_url" +
                        "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                }
            }
        });
    },
};



// WEBPACK FOOTER //
// ./js/routes/woocommerce-cart.js